import {NgModule} from "@angular/core";
import {VerbrauchsanalyseStepVerbrauchsdatenComponent} from "./verbrauchsanalyse/verbrauchsanalyse.step.verbrauchsdaten.component";
import {AdvisorSharedModule} from "./advisor.shared.module";
import {VerbrauchsanalyseAusstiegComponent} from "./verbrauchsanalyse/verbrauchsanalyse.ausstieg.component";

/**
 * Shared module between the advisors that share components for the verbrauchsanalyse. Must bei included in all modules that needs it.
 */
@NgModule({
    declarations: [VerbrauchsanalyseStepVerbrauchsdatenComponent, VerbrauchsanalyseAusstiegComponent],
  imports: [AdvisorSharedModule],
    exports: [VerbrauchsanalyseStepVerbrauchsdatenComponent, VerbrauchsanalyseAusstiegComponent],
})
export class AdvisorVerbrauchsanalyseModule {
}
